export default __webpack_public_path__ + "static/media/bgfooter.a3d55b1c.png";